export const formatPatientShortName = (
  patient?: { name?: string; lastname_1?: string; lastname_2?: string } | null
): string => {
  if (!patient || !patient.name) return '—';
  
  const initial1 = patient.lastname_1 ? `${patient.lastname_1[0]}.` : '';
  const initial2 = patient.lastname_2 ? `${patient.lastname_2[0]}.` : '';
  
  return [patient.name, initial1, initial2].filter(Boolean).join(' ');
};
